import {createFundamentalType, registerFundamentalNode} from "#template/fundamental/factory"
import {StringInfo} from "#template/interface-descriptors"
import {stringMarker} from "#template/nodes/string/marker"
export {stringLikeMarker, isStringLikeNode, isStringLikeNodeClass, isStringLike, stringLikeNode, stringLike} from "#template/nodes/string/marker"
export type {StringLikeNode, StringLike} from "#template/nodes/string/marker"
export const StringFT = createFundamentalType({
    name: "String",
    marker: stringMarker,
    InfoClass: StringInfo,
    icon: "far fa-input-text",
})

@registerFundamentalNode(StringFT, "Likes")
export class StringLikes extends StringFT.Likes {}

@registerFundamentalNode(StringFT, "Switch")
export class StringSwitch extends StringFT.Switch {}

@registerFundamentalNode(StringFT, "Input")
export class StringInput extends StringFT.Input {}

@registerFundamentalNode(StringFT, "Output")
export class StringOutput extends StringFT.Output {}

@registerFundamentalNode(StringFT, "Export")
export class StringExport extends StringFT.Export {}
